import getObjectsViewIcon from "@utils/getObjectsViewIcon"
import getObjectsViewLabel from "@utils/getObjectsViewLabel"

import { TabItem } from "@atoms"

import { TabStack } from "@molecules"

import useViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider.context"

import { ViewSelectorProps } from "./ViewSelector.types"

export default function ViewSelector(props: ViewSelectorProps) {
    const { viewTypes } = props

    const { activeViewType, setActiveViewType } = useViewTypesProvider()

    const tabStackTabs = viewTypes.map((viewType) => (
        <TabItem
            key={viewType}
            iconInReactNode={getObjectsViewIcon(viewType)}
            isSelected={activeViewType === viewType}
            onClick={() => setActiveViewType(viewType)}
            noDebounce={true}
            orientation="vertical"
        >
            {getObjectsViewLabel(viewType)}
        </TabItem>
    ))

    return (
        <TabStack variant="contained" size="lg">
            {tabStackTabs}
        </TabStack>
    )
}
